function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import memoize from 'memoize-one';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { Chart, ChartModelFactory, isFigureChartModel } from '@deephaven/chart';
import { getOpenedPanelMapForDashboard, LayoutUtils } from '@deephaven/dashboard';
import { IrisGridUtils } from '@deephaven/iris-grid';
import { FadeTransition } from '@deephaven/components';
import Log from '@deephaven/log';
import { getActiveTool, getSettings, setActiveTool as setActiveToolAction } from '@deephaven/redux';
import { assertNotNull, Pending, PromiseUtils, TextUtils } from '@deephaven/utils';
import WidgetPanel from "./WidgetPanel.js";
import ToolType from "../linker/ToolType.js";
import { InputFilterEvent } from "../events/index.js";
import { getColumnSelectionValidatorForDashboard, getInputFiltersForDashboard, getIsolatedLinkerPanelIdForDashboard, getLinksForDashboard, getTableMapForDashboard, setDashboardIsolatedLinkerPanelId as setDashboardIsolatedLinkerPanelIdAction } from "../redux/index.js";
import ChartFilterOverlay from "./ChartFilterOverlay.js";
import ChartColumnSelectorOverlay from "./ChartColumnSelectorOverlay.js";
import "./ChartPanel.css";
import { isChartPanelFigureMetadata, isChartPanelTableMetadata } from "./ChartPanelUtils.js";
import { emitFilterColumnsChanged } from "../FilterEvents.js";
import { emitLinkPointSelected } from "../linker/LinkerEvent.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('ChartPanel');
var UPDATE_MODEL_DEBOUNCE = 150;

/** @deprecated Use `PanelMetadata` instead, providing a `name` instead of `figure` */

function hasInputFilter(panel) {
  return panel.inputFilters != null;
}
function hasPanelState(panel) {
  return panel.panelState != null;
}
export class ChartPanel extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "panelContainer", void 0);
    _defineProperty(this, "pending", void 0);
    _defineProperty(this, "getWaitingInputMap", memoize((isFilterRequired, columnMap, filterMap) => {
      if (!isFilterRequired) {
        return new Map();
      }
      var waitingInputMap = new Map(columnMap);
      filterMap.forEach((filter, name) => {
        waitingInputMap.delete(name);
      });
      return waitingInputMap;
    }));
    _defineProperty(this, "getWaitingFilterMap", memoize((isFilterRequired, columnMap, filterMap, linkedColumnMap, inputFilterMap) => {
      if (!isFilterRequired) {
        return new Map();
      }
      var waitingFilterMap = new Map(columnMap);
      filterMap.forEach((filter, name) => {
        waitingFilterMap.delete(name);
      });
      inputFilterMap.forEach((value, name) => {
        waitingFilterMap.delete(name);
      });
      linkedColumnMap.forEach((column, name) => {
        waitingFilterMap.delete(name);
      });
      return waitingFilterMap;
    }));
    _defineProperty(this, "getInputFilterColumnMap", memoize((columnMap, inputFilters) => {
      var inputFilterMap = new Map();
      for (var i = 0; i < inputFilters.length; i += 1) {
        var inputFilter = inputFilters[i];
        var name = inputFilter.name,
          type = inputFilter.type;
        var column = columnMap.get(name);
        if (column != null && column.type === type) {
          inputFilterMap.set(name, inputFilter);
        }
      }
      return inputFilterMap;
    }));
    _defineProperty(this, "getLinkedColumnMap", memoize((columnMap, links) => {
      var linkedColumnMap = new Map();
      var panelId = LayoutUtils.getIdFromPanel(this);
      for (var i = 0; i < links.length; i += 1) {
        var link = links[i];
        var columnName = null;
        if (link.start != null && link.start.panelId === panelId && columnMap.has(link.start.columnName)) {
          columnName = link.start.columnName;
        } else if (link.end && link.end.panelId === panelId && columnMap.has(link.end.columnName)) {
          columnName = link.end.columnName;
        }
        if (columnName != null && columnMap.has(columnName)) {
          var column = columnMap.get(columnName);
          assertNotNull(column);
          linkedColumnMap.set(columnName, column);
        }
      }
      return linkedColumnMap;
    }));
    _defineProperty(this, "getSelectorColumns", memoize((columnMap, linkedColumnMap, columnSelectionValidator) => Array.from(columnMap.values()).map(column => ({
      name: column.name,
      type: column.type,
      isValid: columnSelectionValidator ? columnSelectionValidator(this, column, {
        type: 'chartLink'
      }) : false,
      isActive: linkedColumnMap.has(column.name)
    }))));
    _defineProperty(this, "getWidgetPanelDescriptor", memoize(metadata => {
      var name = 'Chart';
      if (isChartPanelTableMetadata(metadata)) {
        name = metadata.table;
      } else if (isChartPanelFigureMetadata(metadata)) {
        var _metadata$figure;
        name = (_metadata$figure = metadata.figure) !== null && _metadata$figure !== void 0 ? _metadata$figure : name;
      } else {
        var _metadata$name;
        name = (_metadata$name = metadata.name) !== null && _metadata$name !== void 0 ? _metadata$name : name;
      }
      return _objectSpread(_objectSpread({}, metadata), {}, {
        type: 'Chart',
        name
      });
    }));
    this.handleColumnSelected = this.handleColumnSelected.bind(this);
    this.handleColumnMouseEnter = this.handleColumnMouseEnter.bind(this);
    this.handleColumnMouseLeave = this.handleColumnMouseLeave.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.handleReconnect = this.handleReconnect.bind(this);
    this.handleFilterAdd = this.handleFilterAdd.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleLoadError = this.handleLoadError.bind(this);
    this.handleLoadSuccess = this.handleLoadSuccess.bind(this);
    this.handleSettingsChanged = this.handleSettingsChanged.bind(this);
    this.handleOpenLinker = this.handleOpenLinker.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSourceColumnChange = this.handleSourceColumnChange.bind(this);
    this.handleSourceFilterChange = this.handleSourceFilterChange.bind(this);
    this.handleSourceSortChange = this.handleSourceSortChange.bind(this);
    this.handleTabBlur = this.handleTabBlur.bind(this);
    this.handleTabFocus = this.handleTabFocus.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.updateModelFromSource = debounce(this.updateModelFromSource.bind(this), UPDATE_MODEL_DEBOUNCE);
    this.handleClearAllFilters = this.handleClearAllFilters.bind(this);
    this.panelContainer = /*#__PURE__*/React.createRef();
    this.pending = new Pending();
    var _metadata = props.metadata,
      panelState = props.panelState;
    var _ref = panelState !== null && panelState !== void 0 ? panelState : {},
      _ref$filterValueMap = _ref.filterValueMap,
      filterValueMap = _ref$filterValueMap === void 0 ? [] : _ref$filterValueMap,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings;
    this.state = {
      settings,
      error: undefined,
      isActive: false,
      isDisconnected: false,
      isLoading: false,
      isLoaded: false,
      isLinked: _metadata != null && isChartPanelTableMetadata(_metadata) && _metadata.settings.isLinked,
      // Map of all non-empty filters applied to the chart.
      // Initialize the filter map to the previously stored values; input filters will be applied after load.
      filterMap: new Map(filterValueMap),
      // Map of filter values set from links, stored in panelState.
      // Combined with inputFilters to get applied filters (filterMap).
      filterValueMap: new Map(filterValueMap),
      model: undefined,
      columnMap: new Map(),
      // eslint-disable-next-line react/no-unused-state
      panelState
    };
  }
  componentDidMount() {
    if (!this.isHidden()) {
      this.setState({
        isActive: true
      });
      this.initModel();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      inputFilters = _this$props.inputFilters,
      source = _this$props.source,
      makeModel = _this$props.makeModel;
    var _this$state = this.state,
      columnMap = _this$state.columnMap,
      model = _this$state.model,
      filterMap = _this$state.filterMap,
      filterValueMap = _this$state.filterValueMap,
      isLinked = _this$state.isLinked,
      settings = _this$state.settings;
    if (makeModel !== prevProps.makeModel) {
      this.initModel();
    }
    if (model == null) {
      return;
    }
    if (columnMap !== prevState.columnMap) {
      this.pruneFilterMaps();
    }
    if (inputFilters !== prevProps.inputFilters) {
      this.updateChangedInputFilters(inputFilters, prevProps.inputFilters);
    }
    if (filterMap !== prevState.filterMap) {
      this.updateFilters();
    } else if (filterValueMap !== prevState.filterValueMap) {
      this.updatePanelState();
    }
    if (settings !== prevState.settings && isFigureChartModel(model)) {
      model.updateSettings(settings);
      this.updatePanelState();
    }
    if (isLinked !== prevState.isLinked) {
      if (source) {
        if (isLinked) {
          this.startListeningToSource(source);
          this.updateModelFromSource();
        } else {
          this.stopListeningToSource(source);
        }
      }
    } else if (isLinked && source !== prevProps.source) {
      if (prevProps.source) {
        this.stopListeningToSource(prevProps.source);
      }
      if (source) {
        this.startListeningToSource(source);
        this.updateModelFromSource();
      }
    }
  }
  componentWillUnmount() {
    this.pending.cancel();
    var model = this.state.model;
    var source = this.props.source;
    if (model != null && source) {
      this.stopListeningToSource(source);
    }
  }
  initModel() {
    this.setState({
      isLoading: true,
      isLoaded: false,
      error: undefined,
      isDisconnected: false
    });
    var makeModel = this.props.makeModel;
    this.pending.cancel();
    this.pending.add(makeModel(), resolved => {
      resolved.close();
    }).then(this.handleLoadSuccess, this.handleLoadError);
  }
  startListeningToSource(table) {
    log.debug('startListeningToSource', table);
    var model = this.state.model;
    assertNotNull(model);
    var dh = model.dh;
    table.addEventListener(dh.Table.EVENT_CUSTOMCOLUMNSCHANGED, this.handleSourceColumnChange);
    table.addEventListener(dh.Table.EVENT_FILTERCHANGED, this.handleSourceFilterChange);
    table.addEventListener(dh.Table.EVENT_SORTCHANGED, this.handleSourceSortChange);
  }
  stopListeningToSource(table) {
    log.debug('stopListeningToSource', table);
    var model = this.state.model;
    assertNotNull(model);
    var dh = model.dh;
    table.removeEventListener(dh.Table.EVENT_CUSTOMCOLUMNSCHANGED, this.handleSourceColumnChange);
    table.removeEventListener(dh.Table.EVENT_FILTERCHANGED, this.handleSourceFilterChange);
    table.removeEventListener(dh.Table.EVENT_SORTCHANGED, this.handleSourceSortChange);
  }
  loadModelIfNecessary() {
    var _this$state2 = this.state,
      isActive = _this$state2.isActive,
      isLoaded = _this$state2.isLoaded,
      isLoading = _this$state2.isLoading;
    if (isActive && !isLoaded && !isLoading) {
      this.initModel();
    }
  }
  isHidden() {
    var glContainer = this.props.glContainer;
    var isHidden = glContainer.isHidden;
    return isHidden;
  }
  handleColumnSelected(columnName) {
    var glEventHub = this.props.glEventHub;
    var columnMap = this.state.columnMap;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    var column = columnMap.get(columnName);
    if (column == null) {
      return;
    }
    emitLinkPointSelected(glEventHub, panelId, column, {
      type: 'chartLink'
    });
  }
  handleColumnMouseEnter(_ref2) {
    var type = _ref2.type,
      name = _ref2.name;
    var columnSelectionValidator = this.props.columnSelectionValidator;
    log.debug('handleColumnMouseEnter', columnSelectionValidator, type, name);
    if (!columnSelectionValidator) {
      return;
    }
    columnSelectionValidator(this, {
      type,
      name
    }, {
      type: 'chartLink'
    });
  }
  handleColumnMouseLeave() {
    var columnSelectionValidator = this.props.columnSelectionValidator;
    log.debug('handleColumnMouseLeave', columnSelectionValidator);
    if (!columnSelectionValidator) {
      return;
    }
    columnSelectionValidator(this, undefined, {
      type: 'chartLink'
    });
  }
  handleDisconnect() {
    this.setState({
      error: new Error('Figure disconnected'),
      isDisconnected: true
    });
  }
  handleFilterAdd(columns) {
    for (var i = 0; i < columns.length; i += 1) {
      this.openInputFilter(columns[i]);
    }
  }
  handleOpenLinker() {
    var _this$props2 = this.props,
      localDashboardId = _this$props2.localDashboardId,
      setActiveTool = _this$props2.setActiveTool,
      setDashboardIsolatedLinkerPanelId = _this$props2.setDashboardIsolatedLinkerPanelId;
    setDashboardIsolatedLinkerPanelId(localDashboardId, undefined);
    setActiveTool(ToolType.LINKER);
  }
  handleReconnect() {
    this.setState({
      isDisconnected: false,
      error: undefined
    });
    this.sendColumnChange();
    this.updateColumnFilters();
  }
  handleLoadSuccess(model) {
    log.debug('handleLoadSuccess');
    var prevModel = this.state.model;
    this.setState({
      model,
      isLoaded: true
    }, () => {
      var _this$props3 = this.props,
        inputFilters = _this$props3.inputFilters,
        source = _this$props3.source;
      var _this$state3 = this.state,
        filterMap = _this$state3.filterMap,
        isLinked = _this$state3.isLinked;
      if (model !== prevModel) {
        this.sendColumnChange();
        this.updateColumnFilters();
        this.updateInputFilters(inputFilters, filterMap.size > 0 || model.isFilterRequired());
        if (source && isLinked) {
          this.startListeningToSource(source);
          this.updateModelFromSource();
        }
      }
    });
  }
  handleLoadError(error) {
    if (PromiseUtils.isCanceled(error)) {
      return;
    }
    log.error('handleLoadError', error);
    this.setState({
      error,
      isLoading: false
    });
  }
  handleSourceColumnChange() {
    this.updateModelFromSource();
  }
  handleSourceFilterChange() {
    this.updateModelFromSource();
  }
  handleSourceSortChange() {
    this.updateModelFromSource();
  }
  updateModelFromSource() {
    var _this$props4 = this.props,
      metadata = _this$props4.metadata,
      source = _this$props4.source;
    var _this$state4 = this.state,
      isLinked = _this$state4.isLinked,
      model = _this$state4.model;
    if (!isLinked || !model || !source) {
      log.debug2('updateModelFromSource ignoring', isLinked, model, source);
      return;
    }
    var dh = model.dh;
    // By now the model has already been loaded, which is the only other cancelable thing in pending
    this.pending.cancel();
    if (isChartPanelTableMetadata(metadata)) {
      var settings = metadata.settings;
      this.pending.add(ChartModelFactory.makeFigureFromSettings(dh, settings, source), resolved => resolved.close()).then(figure => {
        if (isFigureChartModel(model)) {
          model.setFigure(figure);
        }
      }).catch(this.handleLoadError);
    }
    this.updatePanelState();
  }
  updatePanelState() {
    var sourcePanel = this.props.sourcePanel;
    var _this$state5 = this.state,
      panelState = _this$state5.panelState,
      filterValueMap = _this$state5.filterValueMap,
      settings = _this$state5.settings;
    var _ref3 = panelState !== null && panelState !== void 0 ? panelState : {},
      tableSettings = _ref3.tableSettings;
    if (sourcePanel) {
      // Right now just update the panel state from the source
      // If the source isn't available, just keep the state that's already saved
      if (hasInputFilter(sourcePanel.props) && hasPanelState(sourcePanel.state)) {
        var inputFilters = sourcePanel.props.inputFilters;
        var sourcePanelState = sourcePanel.state.panelState;
        if (sourcePanelState != null) {
          tableSettings = IrisGridUtils.extractTableSettings(sourcePanelState, inputFilters);
        }
      }
    }

    // eslint-disable-next-line react/no-unused-state
    this.setState({
      panelState: {
        settings,
        tableSettings,
        filterValueMap: Array.from(filterValueMap)
      }
    });
  }
  handleError() {
    // Don't want to set an error state, because the user can fix a chart error within the chart itself.
    // We're not loading anymore either so stop showing the spinner so the user can actually click those buttons.
    this.setState({
      isLoading: false
    });
  }
  handleSettingsChanged(update) {
    this.setState(_ref4 => {
      var prevSettings = _ref4.settings;
      var settings = _objectSpread(_objectSpread({}, prevSettings), update);
      log.debug('Updated settings', settings);
      return {
        settings
      };
    });
  }
  handleHide() {
    this.setActive(false);
  }
  handleShow() {
    this.setActive(true);
  }
  handleTabBlur() {
    this.setActive(false);
  }
  handleTabFocus() {
    var isHidden = this.isHidden();
    this.setActive(!isHidden);
  }
  handleUpdate(_ref5) {
    var isLoading = _ref5.isLoading;
    this.setState({
      isLoading
    });
  }
  handleClearAllFilters() {
    // nuke link filter and input filter map
    // input filters only clear themselves if they are not yet empty
    this.setState({
      filterValueMap: new Map(),
      filterMap: new Map()
    });
    this.updatePanelState();
  }

  /**
   * Create an input filter panel for the provided column
   * @param column The column to create the input filter for
   */
  openInputFilter(column) {
    var glEventHub = this.props.glEventHub;
    var name = column.name,
      type = column.type;
    glEventHub.emit(InputFilterEvent.OPEN_INPUT, {
      title: "".concat(name, " Filter"),
      panelState: {
        name,
        type,
        isValueShown: true
      },
      createNewStack: true,
      focusElement: 'input'
    });
  }
  setActive(isActive) {
    this.setState({
      isActive
    }, () => {
      if (isActive) {
        this.loadModelIfNecessary();
      }
    });
  }
  sendColumnChange() {
    var model = this.state.model;
    if (!model) {
      return;
    }
    var glEventHub = this.props.glEventHub;
    var panelId = LayoutUtils.getIdFromPanel(this);
    assertNotNull(panelId);
    emitFilterColumnsChanged(glEventHub, panelId, Array.from(model.getFilterColumnMap().values()));
  }
  getCoordinateForColumn(columnName) {
    var _element$getBoundingC;
    var className = ChartColumnSelectorOverlay.makeButtonClassName(columnName);
    if (!this.panelContainer.current) {
      return null;
    }
    var element = this.panelContainer.current.querySelector(".".concat(className));
    var rect = (_element$getBoundingC = element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) !== null && _element$getBoundingC !== void 0 ? _element$getBoundingC : null;
    if (rect == null || rect.width <= 0 || rect.height <= 0) {
      return null;
    }
    var x = rect.left + rect.width / 2;
    var y = rect.bottom;
    return [x, y];
  }

  /**
   * Set chart filters based on the filter map
   * @param filterMapParam Filter map
   */
  setFilterMap(filterMapParam) {
    log.debug('setFilterMap', filterMapParam);
    this.setState(state => {
      var columnMap = state.columnMap,
        filterMap = state.filterMap;
      var updatedFilterMap = null;
      var filterValueMap = new Map(state.filterValueMap);
      filterMapParam.forEach((_ref6, columnName) => {
        var columnType = _ref6.columnType,
          filterList = _ref6.filterList;
        var column = columnMap.get(columnName);
        if (column == null || column.type !== columnType) {
          return;
        }
        if (filterList.length === 0) {
          log.debug('Ignoring empty filterList for column', columnName);
          return;
        }
        var value = filterList[0].value;
        filterValueMap.set(columnName, value);
        if (filterMap.get(columnName) !== value) {
          if (updatedFilterMap === null) {
            updatedFilterMap = new Map(filterMap);
          }
          updatedFilterMap.set(columnName, value);
        }
      });

      // Don't update filterMap unless the filters actually changed.
      // Otherwise the chart gets stuck on a spinner
      // because it never gets an update event for unchanged filters.
      return {
        filterValueMap,
        filterMap: updatedFilterMap !== null && updatedFilterMap !== void 0 ? updatedFilterMap : filterMap
      };
    });
  }
  unsetFilterValue(columnName) {
    this.setState(state => {
      // We want to unset a value unless there's an input filter for it
      // If there's an input filter, then we want to just set it to that value
      // This way if the user has an input filter and a link, when they delete the link the input filter value takes effect
      var inputFilters = this.props.inputFilters;
      var columnMap = state.columnMap;
      var filterMap = state.filterMap,
        filterValueMap = state.filterValueMap;
      if (!filterValueMap.has(columnName)) {
        return null;
      }
      filterValueMap = new Map(state.filterValueMap);
      filterValueMap.delete(columnName);
      var inputFilterMap = this.getInputFilterColumnMap(columnMap, inputFilters);
      if (inputFilterMap.has(columnName)) {
        var _inputFilterMap$get;
        var filterValue = filterMap.get(columnName);
        var inputFilterValue = (_inputFilterMap$get = inputFilterMap.get(columnName)) === null || _inputFilterMap$get === void 0 ? void 0 : _inputFilterMap$get.value;
        if (inputFilterValue != null && filterValue !== inputFilterValue) {
          filterMap = new Map(state.filterMap);
          if (inputFilterValue.length > 0) {
            filterMap.set(columnName, inputFilterValue);
          } else {
            filterMap.delete(columnName);
          }
        }
      } else {
        filterMap = new Map(state.filterMap);
        filterMap.delete(columnName);
      }
      return {
        filterMap,
        filterValueMap
      };
    });
  }
  updateChangedInputFilters(inputFilters, prevInputFilters) {
    var deletedInputFilters = prevInputFilters.filter(prevInputFilter => inputFilters.find(inputFilter => inputFilter.name === prevInputFilter.name && inputFilter.type === prevInputFilter.type) === undefined);
    if (deletedInputFilters.length > 0) {
      this.deleteInputFilters(deletedInputFilters);
    }
    var changedInputFilters = inputFilters.filter(inputFilter => !prevInputFilters.includes(inputFilter));
    if (changedInputFilters.length > 0) {
      this.updateInputFilters(changedInputFilters);
    }
  }
  updateInputFilters(inputFilters) {
    var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.setState(state => {
      var columnMap = state.columnMap;
      var filterValueMap = new Map(state.filterValueMap);
      var filterMap = new Map(state.filterMap);
      var update = forceUpdate ? {
        filterMap,
        filterValueMap
      } : {};
      for (var i = 0; i < inputFilters.length; i += 1) {
        var _inputFilters$i = inputFilters[i],
          name = _inputFilters$i.name,
          type = _inputFilters$i.type,
          value = _inputFilters$i.value;
        var column = columnMap.get(name);
        if (column != null && column.type === type) {
          if (value != null && filterMap.get(name) !== value) {
            if (value === '') {
              filterMap.delete(name);
            } else {
              filterMap.set(name, value);
            }
            update.filterMap = filterMap;
          }
          if (filterValueMap.has(name)) {
            // Need to unset whatever the linked value was - if they want that value again, they need to double click the link again
            filterValueMap.delete(name);
            update.filterValueMap = filterValueMap;
          }
        }
      }
      log.debug('updateInputFilters', update);
      return update;
    });
  }
  deleteInputFilters(inputFilters) {
    var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.setState(state => {
      var columnMap = state.columnMap,
        filterValueMap = state.filterValueMap;
      var filterMap = new Map(state.filterMap);
      var needsUpdate = forceUpdate;
      for (var i = 0; i < inputFilters.length; i += 1) {
        var _inputFilters$i2 = inputFilters[i],
          name = _inputFilters$i2.name,
          type = _inputFilters$i2.type;
        var column = columnMap.get(name);
        if (column != null && column.type === type) {
          if (filterMap.has(name)) {
            var filterValue = filterMap.get(name);
            if (filterValueMap.has(name)) {
              var linkValue = filterValueMap.get(name);
              if (linkValue !== filterValue && linkValue != null) {
                needsUpdate = true;
                filterMap.set(name, linkValue);
              }
            } else {
              needsUpdate = true;
              filterMap.delete(name);
            }
          }
        }
      }
      log.debug('deleteInputFilters', needsUpdate);
      return needsUpdate ? {
        filterMap
      } : null;
    });
  }
  updateColumnFilters() {
    this.setState(_ref7 => {
      var model = _ref7.model;
      if (!model) {
        return null;
      }
      return {
        columnMap: model.getFilterColumnMap()
      };
    });
  }
  updateFilters() {
    var _this$state6 = this.state,
      columnMap = _this$state6.columnMap,
      filterMap = _this$state6.filterMap,
      model = _this$state6.model;
    assertNotNull(model);
    var waitingInputMap = this.getWaitingInputMap(model.isFilterRequired(), columnMap, filterMap);
    model.setFilter(filterMap);
    if (filterMap.size > 0 && waitingInputMap.size === 0) {
      var defaultTitle = model.getDefaultTitle();
      var filterTitle = TextUtils.join(Array.from(filterMap.entries()).map(_ref8 => {
        var _ref9 = _slicedToArray(_ref8, 2),
          name = _ref9[0],
          value = _ref9[1];
        return "".concat(name, ": ").concat(value);
      }));
      if (defaultTitle) {
        model.setTitle("".concat(defaultTitle, "<br><span style=\"font-size: smaller\">").concat(filterTitle, "</span>"));
      } else {
        model.setTitle(filterTitle);
      }
      log.debug2('updateFilters filters set', filterMap);
      this.setState({
        isLoading: true
      });
    } else {
      log.debug2('updateFilters waiting on inputs', waitingInputMap);
      model.setTitle(model.getDefaultTitle());
      this.setState({
        isLoading: false
      });
    }
    this.updatePanelState();
  }

  /**
   * Removes any set filter values that are no longer part of the model
   */
  pruneFilterMaps() {
    this.setState(state => {
      var columnMap = state.columnMap;
      var filterMap = new Map(state.filterMap);
      var filterValueMap = new Map(state.filterValueMap);
      var newState = {};
      state.filterValueMap.forEach((value, name) => {
        if (!columnMap.has(name)) {
          filterValueMap.delete(name);
          newState.filterValueMap = filterValueMap;
        }
      });
      state.filterMap.forEach((value, name) => {
        if (!columnMap.has(name)) {
          filterMap.delete(name);
          newState.filterMap = filterMap;
        }
      });
      return newState;
    });
  }
  render() {
    var _this$props5 = this.props,
      columnSelectionValidator = _this$props5.columnSelectionValidator,
      glContainer = _this$props5.glContainer,
      glEventHub = _this$props5.glEventHub,
      inputFilters = _this$props5.inputFilters,
      isLinkerActive = _this$props5.isLinkerActive,
      links = _this$props5.links,
      metadata = _this$props5.metadata,
      settings = _this$props5.settings,
      Plotly = _this$props5.Plotly,
      containerRef = _this$props5.containerRef,
      onPlotlyRelayout = _this$props5.onPlotlyRelayout,
      onPlotlyClick = _this$props5.onPlotlyClick,
      onPlotlyDoubleClick = _this$props5.onPlotlyDoubleClick,
      onPlotlySelected = _this$props5.onPlotlySelected,
      onPlotlyDeselect = _this$props5.onPlotlyDeselect,
      onPlotlyClickAnnotation = _this$props5.onPlotlyClickAnnotation,
      onPlotlyLegendClick = _this$props5.onPlotlyLegendClick,
      onPlotlyLegendDoubleClick = _this$props5.onPlotlyLegendDoubleClick,
      onPlotlyWebGlContextLost = _this$props5.onPlotlyWebGlContextLost,
      onPlotElementChange = _this$props5.onPlotElementChange;
    var _this$state7 = this.state,
      columnMap = _this$state7.columnMap,
      filterMap = _this$state7.filterMap,
      error = _this$state7.error,
      model = _this$state7.model,
      isActive = _this$state7.isActive,
      isDisconnected = _this$state7.isDisconnected,
      isLoaded = _this$state7.isLoaded,
      isLoading = _this$state7.isLoading;
    var inputFilterMap = this.getInputFilterColumnMap(columnMap, inputFilters);
    var linkedColumnMap = this.getLinkedColumnMap(columnMap, links);
    var waitingInputMap = model != null ? this.getWaitingInputMap(model.isFilterRequired(), columnMap, filterMap) : new Map();
    var waitingFilterMap = model != null ? this.getWaitingFilterMap(model.isFilterRequired(), columnMap, filterMap, linkedColumnMap, inputFilterMap) : new Map();
    var errorMessage = error != null ? "Unable to open chart. ".concat(error) : undefined;
    var isWaitingForFilter = waitingInputMap.size > 0;
    var isSelectingColumn = columnMap.size > 0 && isLinkerActive;
    var descriptor = this.getWidgetPanelDescriptor(metadata);
    return /*#__PURE__*/_jsx(WidgetPanel, {
      className: classNames('iris-chart-panel', {
        'input-required': isWaitingForFilter
      }),
      componentPanel: this,
      glContainer: glContainer,
      glEventHub: glEventHub,
      onHide: this.handleHide,
      onClearAllFilters: this.handleClearAllFilters,
      onShow: this.handleShow,
      onTabBlur: this.handleTabBlur,
      onTabFocus: this.handleTabFocus,
      errorMessage: errorMessage,
      isDisconnected: isDisconnected,
      isLoading: isLoading,
      isLoaded: isLoaded,
      descriptor: descriptor,
      children: /*#__PURE__*/_jsxs("div", {
        ref: this.panelContainer,
        className: "chart-panel-container h-100 w-100",
        children: [/*#__PURE__*/_jsx("div", {
          className: "chart-container h-100 w-100",
          children: isLoaded && model && /*#__PURE__*/_jsx(Chart, {
            isActive: isActive,
            model: model,
            settings: settings,
            onDisconnect: this.handleDisconnect,
            onReconnect: this.handleReconnect,
            onUpdate: this.handleUpdate,
            onError: this.handleError,
            onSettingsChanged: this.handleSettingsChanged,
            Plotly: Plotly,
            containerRef: containerRef,
            onPlotlyRelayout: onPlotlyRelayout,
            onPlotlyClick: onPlotlyClick,
            onPlotlyDoubleClick: onPlotlyDoubleClick,
            onPlotlySelected: onPlotlySelected,
            onPlotlyDeselect: onPlotlyDeselect,
            onPlotlyClickAnnotation: onPlotlyClickAnnotation,
            onPlotlyLegendClick: onPlotlyLegendClick,
            onPlotlyLegendDoubleClick: onPlotlyLegendDoubleClick,
            onPlotlyWebGlContextLost: onPlotlyWebGlContextLost,
            onPlotElementChange: onPlotElementChange
          })
        }), /*#__PURE__*/_jsx(FadeTransition, {
          in: isWaitingForFilter && !isSelectingColumn && !isLoading,
          mountOnEnter: true,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx(ChartFilterOverlay, {
            inputFilterMap: inputFilterMap,
            linkedColumnMap: linkedColumnMap,
            onAdd: this.handleFilterAdd,
            onOpenLinker: this.handleOpenLinker,
            columnMap: columnMap,
            waitingFilterMap: waitingFilterMap,
            waitingInputMap: waitingInputMap
          })
        }), /*#__PURE__*/_jsx(FadeTransition, {
          in: isSelectingColumn,
          mountOnEnter: true,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx(ChartColumnSelectorOverlay, {
            columns: this.getSelectorColumns(columnMap, linkedColumnMap, columnSelectionValidator),
            onColumnSelected: this.handleColumnSelected,
            onMouseEnter: this.handleColumnMouseEnter,
            onMouseLeave: this.handleColumnMouseLeave
          })
        })]
      })
    });
  }
}
_defineProperty(ChartPanel, "defaultProps", {
  columnSelectionValidator: null,
  isLinkerActive: false,
  source: null,
  sourcePanel: null,
  panelState: null,
  settings: {},
  containerRef: null
});
_defineProperty(ChartPanel, "displayName", 'ChartPanel');
_defineProperty(ChartPanel, "COMPONENT", 'ChartPanel');
var mapStateToProps = (state, ownProps) => {
  var localDashboardId = ownProps.localDashboardId,
    metadata = ownProps.metadata;
  var sourcePanelId;
  if (metadata != null && isChartPanelTableMetadata(metadata)) {
    sourcePanelId = metadata.sourcePanelId;
  }
  var panelTableMap = getTableMapForDashboard(state, localDashboardId);
  var openedPanelMap = getOpenedPanelMapForDashboard(state, localDashboardId);
  var activeTool = getActiveTool(state);
  var isolatedLinkerPanelId = getIsolatedLinkerPanelIdForDashboard(state, localDashboardId);
  var isLinkerActive = activeTool === ToolType.LINKER && isolatedLinkerPanelId === undefined;
  return {
    columnSelectionValidator: getColumnSelectionValidatorForDashboard(state, localDashboardId),
    isLinkerActive,
    inputFilters: getInputFiltersForDashboard(state, localDashboardId),
    links: getLinksForDashboard(state, localDashboardId),
    source: sourcePanelId != null ? panelTableMap.get(sourcePanelId) : undefined,
    sourcePanel: sourcePanelId != null ? openedPanelMap.get(sourcePanelId) : undefined,
    settings: getSettings(state)
  };
};
var ConnectedChartPanel = connect(mapStateToProps, {
  setActiveTool: setActiveToolAction,
  setDashboardIsolatedLinkerPanelId: setDashboardIsolatedLinkerPanelIdAction
}, null, {
  forwardRef: true
})(ChartPanel);
export default ConnectedChartPanel;
//# sourceMappingURL=ChartPanel.js.map